import React, { useState, useEffect } from 'react'
import './css/Navbar.css'
import { Link } from 'react-router-dom'
import LogoIcon from './../assets/icons/Logo Icon.png'
import { FiMenu } from 'react-icons/fi';
import { IoMdClose } from 'react-icons/io';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

function Navbar({ bgColor }) {
  const [open, setOpen] = useState(false);

  open ? disableBodyScroll(document) : enableBodyScroll(document);

  useEffect(() => {
    const resetOnResize = () => {
      if (window.innerWidth >= 750) setOpen(false);
    };
    window.addEventListener("resize", resetOnResize);
    return () => {
      window.removeEventListener("resize", resetOnResize);
    };
  })

  return (
    <div className='Navbar' style={{ backgroundColor: bgColor }}>
        <div className='logo'>
            <img src={LogoIcon} alt='Logo Icon' />
        </div>
        <div className='routes' style={{ left: open? "0%" : "100%" }}>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/contact">Contact</Link>
        </div>
        <div className='hamburger' onClick={()=>{setOpen(prev => !prev)}}>
            { !open ? <FiMenu /> : <IoMdClose/>}
        </div>
    </div>
  )
}

export default Navbar